export const DEFAULT_TEAM_TARGETS = {
  "RC DCD": [
    { daily: 18, bonus: 25 },
    { daily: 21, bonus: 50 },
    { daily: 24, bonus: 75 },
  ],
  "RC PCB": [
    { daily: 11, bonus: 25 },
    { daily: 13, bonus: 50 },
    { daily: 15, bonus: 75 },
  ],
  "RC PC": [
    { daily: 11, bonus: 25 },
    { daily: 13, bonus: 50 },
    { daily: 15, bonus: 75 },
  ],
  "RC PRINTERS & PERIPHERALS": [
    { daily: 11, bonus: 25 },
    { daily: 13, bonus: 50 },
    { daily: 15, bonus: 75 },
  ],
  "RC MCD": [
    { daily: 11, bonus: 25 },
    { daily: 13, bonus: 50 },
    { daily: 15, bonus: 75 },
  ],
  "RC PED": [
    { daily: 11, bonus: 25 },
    { daily: 13, bonus: 50 },
    { daily: 15, bonus: 75 },
  ],
  ALL: [
    { daily: 11, bonus: 25 },
    { daily: 13, bonus: 50 },
    { daily: 15, bonus: 75 },
  ],
};

export const TEAM_TARGET_KEYS = Object.keys(DEFAULT_TEAM_TARGETS);

function n(value) {
  return Number(value || 0) || 0;
}

function cloneTiers(tiers) {
  return (tiers || []).map((tier) => ({
    daily: n(tier.daily),
    bonus: n(tier.bonus),
  }));
}

export function sanitizeTeamTargets(config) {
  const clean = {};
  Object.entries(config || {}).forEach(([team, tiers]) => {
    if (!Array.isArray(tiers)) return;
    const rows = tiers
      .map((tier) => ({ daily: n(tier.daily), bonus: n(tier.bonus) }))
      .filter((tier) => tier.daily > 0)
      .sort((a, b) => a.daily - b.daily);
    if (rows.length) clean[team] = rows;
  });
  return clean;
}

export function getTeamTargetTiers(team, config = {}) {
  const clean = sanitizeTeamTargets(config);
  const targetTeam = team || "ALL";
  const tiers =
    clean[targetTeam] ||
    DEFAULT_TEAM_TARGETS[targetTeam] ||
    clean.ALL ||
    DEFAULT_TEAM_TARGETS.ALL ||
    DEFAULT_TEAM_TARGETS["RC PCB"];
  return cloneTiers(tiers);
}

export function buildHistoryTierMap(config = {}) {
  const map = {};
  TEAM_TARGET_KEYS.forEach((team) => {
    map[team] = getTeamTargetTiers(team, config);
  });
  map.default = getTeamTargetTiers("ALL", config);
  return map;
}
